import React, { useEffect, useState } from 'react';

// import './App.css'
// import './index.css'

import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import './styles.css';
import { Button, TextField } from '@material-ui/core';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 1px 10px #dddddd !important',
        marginBottom: '2%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    heading1: {
        fontFamily: 'Rubik',
        color: '#111',
        fontSize: '18px',
        fontWeight: 500,
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    cardCustom: {
        padding: '0',
    },
    question: {
        // fontSize: theme.typography.pxToRem(12),
        // fontWeight: theme.typography.fontWeightMedium,
        color: '#111',
        fontFamily: 'Rubik',
        fontSize: '15px',
        fontWeight: 500,
        marginLeft: '10px',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    displayInline: {
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 0,
        '& li': {
            display: 'inline-block',
        },
    },
}));

function CpsCheckList() {
    /** CHANGE THIS VARIABLE BASED ON USER
     *
     * Might Possible Values
     ** RemarksByClient
     ** RemarksByEM
     ** RemarksByET
     **/
    const question = {
        Question: [
            {
                questionId: '1',
                isCategory: true,
                questionText: 'Financial Information',
                responseType: 'NA',
                RemarksByClient: null,
                RemarksByEM: null,
                RemarksByET: null,
                booleanResponse: 'NA',
                subQuestions: [
                    {
                        questionId: '2',
                        isCategory: true,
                        questionText: 'Financial Statements',
                        responseType: 'NA',
                        RemarksByClient: null,
                        RemarksByEM: null,
                        RemarksByET: null,
                        booleanResponse: 'NA',
                        subQuestions: [
                            {
                                questionId: '3',
                                isCategory: false,
                                questionText: 'Audited Financial Statements and IT returns of the last year.',
                                responseType: 'String',
                                RemarksByClient: null,
                                RemarksByEM: null,
                                RemarksByET: null,
                                booleanResponse: 'NA',
                            },
                            {
                                questionId: '4',
                                isCategory: false,
                                questionText: 'Copies of the Annual and other Return filed with ROC for last Financial year.',
                                responseType: 'String',
                                RemarksByClient: null,
                                RemarksByEM: null,
                                RemarksByET: null,
                                booleanResponse: 'NA',
                            },
                        ],
                    },
                    {
                        questionId: '5',
                        isCategory: true,
                        questionText: 'Statutory Compliance',
                        responseType: 'NA',
                        RemarksByClient: null,
                        RemarksByEM: null,
                        RemarksByET: null,
                        booleanResponse: 'NA',
                        subQuestions: [
                            {
                                questionId: '6',
                                isCategory: true,
                                questionText: 'GST',
                                responseType: 'NA',
                                RemarksByClient: null,
                                RemarksByEM: null,
                                RemarksByET: null,
                                booleanResponse: 'NA',
                                subQuestions: [
                                    {
                                        questionId: '7',
                                        isCategory: false,
                                        questionText: 'a) GSTR 3B return',
                                        responseType: 'String',
                                        RemarksByClient: null,
                                        RemarksByEM: null,
                                        RemarksByET: null,
                                        booleanResponse: 'NA',
                                    },
                                    {
                                        questionId: '8',
                                        isCategory: false,
                                        questionText: 'b) GSTR 1',
                                        responseType: 'String',
                                        RemarksByClient: null,
                                        RemarksByEM: null,
                                        RemarksByET: null,
                                        booleanResponse: 'NA',
                                    },
                                    {
                                        questionId: '9',
                                        isCategory: false,
                                        questionText: 'c) GST workings',
                                        responseType: 'String',
                                        RemarksByClient: null,
                                        RemarksByEM: null,
                                        RemarksByET: null,
                                        booleanResponse: 'NA',
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    };
    const USER = 'RemarksByClient';
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState('');
    const [answers, setAnswers] = useState({
        answers: [],
    });
    const onAnswer = (qid, value) => {
        setAnswers((data) => {
            const id = data.answers.findIndex((answer) => answer.qid === qid);
            if (id !== -1) {
                data.answers[id][USER] = value;
            } else {
                data.answers.push({ qid, [USER]: value });
            }
            return { ...data };
        });
    };
    const onHandleCheckbox = (qid, value) => {
        //Handle File Upload Here if Doing it on Backend

        setAnswers((data) => {
            const id = data.answers.findIndex((answer) => answer.qid === qid);
            ////console.log("QID : ",qid);
            ////console.log("VAL : ",value);
            ////console.log("INDX : ",id);
            if (id !== -1) {
                data.answers[id].checked = value;
            } else {
                data.answers.push({ qid, checked: value });
            }
            return { ...data };
        });
    };
    const sumbit = () => {
        ////console.log(answers)
    };
    const handleChange = (panel) => {
        setExpanded(expanded === panel ? '' : panel);
    };

    return (
        <div>
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom} style={{ paddingBottom: '0' }}>
                    <CardHeader
                        className="borderBottomLine"
                        action={
                            <Button variant="outlined" color="primary" size="small" className={classes.button}>
                                Add Additional Questions
                            </Button>
                        }
                        title="CPS Checklist Generator"
                    />

                    {question.Question.map((question, key) => (
                        <Accordion
                            square
                            expanded={expanded === 'panel' + question.questionId}
                            onChange={() => handleChange('panel' + question.questionId)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreOutlinedIcon variant="outlined" color="primary" />}
                                id="panel1a-header"
                                className="padding10"
                            >
                                <Typography className={classes.heading}>{question.questionText}</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.accordContentSummary}>
                                <Grid container spacing={3} className="main-container">
                                    <Grid item xs={12} sm={12}>
                                        <FormControl fullWidth className={classes.margin}>
                                            <Question
                                                question={question}
                                                key={key}
                                                onAnswer={onAnswer}
                                                data={answers}
                                                onHandleCheckbox={onHandleCheckbox}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </CardContent>
            </Card>
            <Grid item sm={12} className={classes.fullWidth}>
                <div>
                    <ul className={classes.displayInline}>
                        <li>
                            <Button variant="contained" className="btnBlue ml10 txt-cap" color="primary" onClick={sumbit}>
                                Submit
                            </Button>
                        </li>
                    </ul>
                </div>
            </Grid>
        </div>
    );
}

export default CpsCheckList;

const Question = ({ question, onAnswer, data, onHandleCheckbox, depth = 1 }) => {
    const [internalDepth, setInternalDepth] = useState(depth);

    const classes = useStyles();

    useEffect(() => {
        setInternalDepth(depth);
    }, [depth]);

    if (question.isCategory) {
        return (
            <div>
                {question.subQuestions.map((question, key) => (
                    <>
                        {question.isCategory ? (
                            <Typography className={classes.heading1}>{key + 1 + ') ' + question.questionText}</Typography>
                        ) : (
                            ''
                        )}
                        <Question
                            question={question}
                            key={key}
                            onAnswer={onAnswer}
                            onHandleCheckbox={onHandleCheckbox}
                            data={data}
                            depth={internalDepth + 1}
                        />
                    </>
                ))}
            </div>
        );
    } else {
        let index = data.answers.findIndex((answer) => answer.qid === question.questionId);
        let checked = index != -1 ? data.answers[index].checked : false;
        return (
            <div className={'depth-' + internalDepth}>
                <div style={{ display: 'inline-flex', marginTop: '10px' }}>
                    <Checkbox
                        style={{ padding: '0' }}
                        color="primary"
                        checked={checked}
                        onChange={(e) => {
                            onHandleCheckbox(question.questionId, e.target.checked);
                        }}
                    />
                    <Typography className={classes.question}>{question.questionText}</Typography>
                </div>
                <div>
                    <TextField
                        label="Remarks by Audit Team"
                        className="textfieldBottomLine w100"
                        defaultValue="Enter Remarks"
                        multiline
                        rows={2}
                        disabled={!checked}
                        style={{ fontSize: '12px' }}
                        onChange={(e) => {
                            onAnswer && onAnswer(question.questionId, e.target.value);
                        }}
                    />
                </div>
            </div>
        );
    }
};
